import type { WidenLocale } from '@mangovoice/types'

export const soundClipsEn = {
  list: {
    title: 'Sound Clips',
    loading: 'Loading sound clips...',
    error: 'Error',
    empty: 'No sound clips found',
    emptyDescription:
      'There are currently no sound clips configured for this PBX.',
    noResults: 'No results',
    noResultsDescription: 'No sound clips matching your search.',
    columnName: 'Name',
    columnFeatureCode: 'Feature Code',
    columnUpdated: 'Updated',
    columnActions: 'Actions',
    featureCodeNone: 'N/A',
    createButton: '+ New Sound Clip',
    deleteConfirmTitle: 'Delete Sound Clip',
    deleteConfirmMessage:
      'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
    deleteConfirmButton: 'Delete',
    deleteSuccess: 'Sound clip deleted.',
    deleteError: 'Failed to delete sound clip.',
    searchPlaceholder: 'Search sound clips...',
    recordingInfo:
      'Dial *99 from your phone to record a new sound clip. Dial *100–*109 to re-record an existing clip.',
    audioLoadError: "Audio couldn't be loaded — may need to be re-recorded.",
  },
  create: {
    title: 'New Sound Clip',
    nameLabel: 'Name',
    namePlaceholder: 'Enter sound clip name',
    featureCodeLabel: 'Feature Code',
    featureCodeNone: 'None',
    audioFileLabel: 'Audio File',
    audioFilePlaceholder:
      'Drag & drop a WAV or MP3 file here, or click to browse',
    audioFileAccepted: 'WAV, MP3 (max 25 MB)',
    cancel: 'Cancel',
    submit: 'Upload Sound Clip',
    creating: 'Uploading...',
    success: 'Sound clip created successfully.',
    error: 'Failed to create sound clip.',
    nameRequired: 'Name is required.',
    audioFileRequired: 'An audio file is required.',
  },
  edit: {
    title: 'Edit Sound Clip',
    loading: 'Loading sound clip...',
    notFound: 'Sound clip not found.',
    backToList: '← Back to list',
    nameLabel: 'Name',
    namePlaceholder: 'Enter sound clip name',
    featureCodeLabel: 'Feature Code',
    featureCodeNone: 'None',
    audioFileLabel: 'Replace Audio File',
    audioFilePlaceholder:
      'Drag & drop a new file to replace, or click to browse',
    audioFileAccepted: 'WAV, MP3 (max 25 MB)',
    currentAudio: 'Current Audio',
    playCurrentAudio: 'Play Current Audio',
    stopAudio: 'Stop',
    audioLoadError:
      "This clip's audio couldn't be loaded — it may need to be re-recorded.",
    createdLabel: 'Created',
    updatedLabel: 'Last Updated',
    cancel: 'Cancel',
    submit: 'Save Changes',
    saving: 'Saving...',
    success: 'Sound clip updated successfully.',
    error: 'Failed to update sound clip.',
    deleteButton: 'Delete Sound Clip',
  },
  upload: {
    invalidType: 'Unsupported file type. Please upload a WAV or MP3.',
    tooLarge: 'File is too large. The maximum size is 25 MB.',
  },
} as const

export type SoundClipsLocale = WidenLocale<typeof soundClipsEn>
